class TasteSectionComponent extends HTMLElement {
  constructor() {
    super();
    this.videoElement = null;
    this.observer = null;
    this.hasPlayed = false;
    this.endTimer = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const animationContainer = this.querySelector('[ref="animationContainer"]');
    const videoElement = this.querySelector('[ref="videoElement"]');
    
    if (!animationContainer || !videoElement) return;

    this.videoElement = videoElement;

    // Set up intersection observer to trigger video playback when section is visible
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.playVideo();
          } else {
            // When leaving viewport, pause video but keep current time
            // This allows it to resume from where it left off if re-entering
            if (this.videoElement && !this.videoElement.ended) {
              this.videoElement.pause();
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    this.observer.observe(animationContainer);

    // Handle video end event - pause at last frame for 2 seconds, then loop
    this.videoElement.addEventListener('ended', () => {
      // Keep video at last frame by pausing
      this.videoElement.pause();
      this.hasPlayed = true;
      
      // Clear any existing timer
      if (this.endTimer) {
        clearTimeout(this.endTimer);
      }
      
      // After 2 seconds, restart the video
      this.endTimer = setTimeout(() => {
        if (this.videoElement) {
          this.videoElement.currentTime = 0;
          this.videoElement.play().catch((error) => {
            console.log('Video play failed:', error);
          });
        }
      }, 2000);
    });

    // Handle video loadedmetadata to ensure we can seek to end if needed
    this.videoElement.addEventListener('loadedmetadata', () => {
      // Video metadata loaded, ready to play
    });
  }

  playVideo() {
    if (!this.videoElement) return;

    // If video has ended, restart from beginning
    if (this.videoElement.ended) {
      this.videoElement.currentTime = 0;
      this.hasPlayed = false;
    }

    // Play video (muted, as set in HTML)
    const playPromise = this.videoElement.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Video started playing successfully
        })
        .catch((error) => {
          // Auto-play was prevented or video failed to play
          console.log('Video play failed:', error);
        });
    }
  }

  disconnectedCallback() {
    // Clean up observer
    if (this.observer) {
      this.observer.disconnect();
    }

    // Clear timer if exists
    if (this.endTimer) {
      clearTimeout(this.endTimer);
      this.endTimer = null;
    }

    // Pause video if still playing
    if (this.videoElement && !this.videoElement.paused) {
      this.videoElement.pause();
    }
  }
}

customElements.define('taste-section-component', TasteSectionComponent);
